import React from 'react';
import { Col, Container, Row } from 'reactstrap';

import BG3 from '../assets/img/bg-3.png';
import icon1 from '../assets/img/icon-1.png';
import icon2 from '../assets/img/icon-2.png';
import icon3 from '../assets/img/icon-3.png';
import icon4 from '../assets/img/icon-4.png';

const Steps = () => {
    return (
        <section className="steps-sec">
            <Container >
                <Row>
                    <Col>
                        <div className="steps_inner">
                            <img src={BG3} alt="" className="w-100" />
                            <div className="steps-header">
                                <h6 className="text-center para-18 text-white" data-aos="fade-up">How Testigo X-Ray Works</h6>
                                <h3 className="heading-1fff text-white text-center" data-aos="fade-up">Easy 4 Steps To Get Your On Demand X-Ray Solution</h3>
                            </div>
                            <div className="steps_body" data-aos="fade-up">
                                <div className="stepsBody_header">
                                    <div className="row align-items-center">
                                        <div className="col-lg-5">
                                            <h3 className="heading-1fff text-white">Easy Steps To Get Your Solution</h3>
                                        </div>
                                        <div className="col-lg-4">
                                            <p className="para-18 text-white">Select preferred doctor and time slot to book appointment or consultation</p>
                                        </div>
                                        <div className="col-lg-3">
                                            <a href="#" className="btn custom-btn2">Make an Appointment</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="stepsBody_body">
                                <div className="row">
                                    <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-duration={1000}>
                                        <div className="stepsBbody_box">
                                            <img src={icon1} alt="" />
                                            <h6>Search Doctor</h6>
                                            <p>Before book appointment first of all search doctor by category</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-duration={2000}>
                                        <div className="stepsBbody_box">
                                            <img src={icon2} alt="" />
                                            <h6>Choose Your Location</h6>
                                            <p>Before book appointment first of all search doctor by category</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-duration={2800}>
                                        <div className="stepsBbody_box">
                                            <img src={icon3} alt="" />
                                            <h6>Schedule Appointment</h6>
                                            <p>Before book appointment first of all search doctor by category</p>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-duration={4000}>
                                        <div className="stepsBbody_box">
                                            <img src={icon4} alt="" />
                                            <h6>Get Your Solutions</h6>
                                            <p>Before book appointment first of all search doctor by category</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Steps;